export const removeMessageMutation = `
        mutation RemoveMessage($messageId: ID!) {
          removeMessage(id: $messageId)
        }
      `;
